import { z } from 'zod';
import { inviteFormSchema } from './schema';

/**
 * Form schema for InviteMemberDialog (MYN-202, FR-174): the shared
 * `inviteFormSchema` plus the optional sector pick. Kept as its own extension
 * because `ShareProfileDialog` also uses the shared schema and a recipient has
 * no sector. The select yields a string ('' = none), converted by
 * `toInviteSectorId` before it reaches the API.
 */
export const inviteMemberFormSchema = inviteFormSchema.extend({
  sectorId: z.string().optional(),
});

export type InviteMemberFormValues = z.infer<typeof inviteMemberFormSchema>;

/** Pure: the numeric sector id for the request, or undefined when none was chosen. */
export function toInviteSectorId(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : undefined;
}
